import { useEffect, useState } from "react";

export const useShippingLabelPdf = (base64: string | null | undefined) => {
  const [document, setDocument] = useState<{ source: string | null | undefined; url: string | null; error: boolean }>({
    source: base64,
    url: null,
    error: false,
  });
  useEffect(() => {
    if (!base64) {
      setDocument({ source: base64, url: null, error: false });
      return;
    }
    let url: string | null = null;
    try {
      const decoded = atob(base64);
      const bytes = Uint8Array.from(decoded, character => character.charCodeAt(0));
      url = URL.createObjectURL(new Blob([bytes], { type: "application/pdf" }));
      setDocument({ source: base64, url, error: false });
    } catch {
      setDocument({ source: base64, url: null, error: true });
    }
    return () => {
      if (url) URL.revokeObjectURL(url);
    };
  }, [base64]);
  return document.source === base64 ? document : { url: null, error: false };
};
